/*eslint-disable */
define({
    ENTER: 13,
    ESCAPE: 27,
    BACKSPACE: 8,
    DELETE: 46
});
